/**
 * add parent category key to child category
 * @param {*} parentCategory
 * @param {*} category
 */
export const mapCategory = (parentCategory) => (category) => ({ ...category, parentCategory });

export const flatCategory = (category) => {
  if (!category.children || category.children.length === 0) return [];

  // eslint-disable-next-line no-use-before-define
  return [...flatCategories(category.children, category.key || category.id)];
};

export const flatCategories = (categories, parentCategory = null) => [
  ...categories.map(mapCategory(parentCategory)),
  ...categories.reduce((result, category) => [...result, ...flatCategory(category)], []),
];

export const mapTreeChildrenToContentCategories = (treeItem) => {
  const { name, key, images } = treeItem;
  const [image] = Object.values(images) || [''];

  return {
    key,
    name,
    category_url: `/shop/category/${key}`,
    image_url: image,
  };
};

export const mergeCategoryTreeItemToCategoryContentItem = (treeItem, contentItem) => {
  // eslint-disable-next-line camelcase
  const { brands, description, meta_description } = contentItem;
  const { name } = treeItem;
  const categories = treeItem.children.map(mapTreeChildrenToContentCategories);

  return {
    brands,
    categories,
    description,
    // eslint-disable-next-line camelcase
    meta_description,
    title: name,
  };
};
